<template>
    <mu-col span="12">
        <mu-row gutter class="m-0 p-0">
            <mu-col span="2" md="1" lg="1" xl="1" class="d-flex justify-content-center align-items-center img-logo-brand">
                <router-link to="/" custom v-slot="{ navigate }">
                    <span @click="navigate" @keypress.enter="navigate" role="link">
                        <picture @click="tab_active = 0">
                            <source srcset="/images/logos/vallartaplus_1.webp" type="image/webp" :alt="$t('alt.logo')" class="size-logo"/>
                            <img src="/images/logos/vallartaplus_1.png" :alt="$t('alt.logo')" class="size-logo"/>
                        </picture>
                    </span>
                </router-link>
            </mu-col>
            <mu-col span="10" md="11" lg="11" xl="11" class="m-0 p-0 navbar-sections">
                <mu-row gutter class="m-0 h-100">
                    <mu-col span="12" class="p-0 m-0 h-100">
                        <mu-row class="h-100">
                            <mu-col class="h-100 d-flex align-items-center justify-content-center" v-for="item, index in menu" :key="`col_${index}`" v-if="item.name != 'schedules'">
                                <a :href="item.link" target="_blank" v-if="['shipper', 'traveller', 'hotel'].includes(item.name)">
                                    <span class="d-flex align-items-center">
                                        <span v-if="item.html != null" v-html="item.html" class="mr-1"></span>
                                        <label class="buttonText" v-html="$t(`button_action.${item.name}`)"></label>
                                    </span>
                                </a>
                                <a :href="item.link" v-else>
                                    <span class="d-flex align-items-center">
                                        <span v-if="item.html != null" v-html="item.html" class="mr-1"></span>
                                        <label class="buttonText" v-html="$t(`button_action.${item.name}`)"></label>
                                    </span>
                                </a>
                            </mu-col>
                            <mu-col class="h-100 d-flex align-items-center justify-content-center" v-else>
                                <a :href="item.link">
                                    <div>
                                        <span class="d-flex align-items-center">
                                            <img class='buttonLogoCombined mr-1' src='/images/navbar/new_icons/schedules_black.svg'/>
                                            <label class="buttonTextCombined">
                                                {{ $t('button_action.schedules') }}
                                            </label>
                                        </span>
                                    </div>
                                    <div>
                                        <span class="d-flex align-items-center">
                                            <img class='buttonLogoCombined mr-1' src='/images/navbar/new_icons/rates_black.svg'/>
                                            <label class="buttonTextCombined">
                                                {{ $t('button_action.rates') }}
                                            </label>
                                        </span>
                                    </div>
                                </a>
                            </mu-col>
                        </mu-row>
                    </mu-col>
                </mu-row>
            </mu-col>
        </mu-row>
    </mu-col>
</template>
<script>

// HELPERS
import _FrequentTravellerHelper from '@/store/helpers/frequenttraveller/frequenttraveller'
import _GlobalHelper from '@/store/helpers/global'
// IMG
import mx from '@@/images/mx.png'
import us from '@@/images/us.svg'
import icon from '@@/images/covid/icono-covid.png'
// VUEX
import { mapMutations, mapGetters } from 'vuex'
export default {
	name: 'nav-bar',
	components: {
	},
	data() {
		return {
			open_drawer: false,
			activeTooltip: false,
			tab_active: 0,
			countries: [
				{
					img: mx,
					tag: 'es  (mx)'
				},
				{
					img: us,
					tag: 'en  (us)'
				}
			],
			select_country: mx,
			icon: icon,
            show_tour: true,
            menu: [
                {
                    name: "cellphones",
                    html: "<img class='buttonLogo' src='/images/navbar/new_icons/cellphones_black.svg'/>",
                    link: "/contact-center"
                },

                {
                    name: "wifi",
                    html: "<img class='buttonLogo' src='/images/navbar/new_icons/wifi_black.svg'/>",
                    link: "/internet"
                },
                {
                    name: "schedules",
                    html: null,
                    link: "/horarios-y-tarifas"
                },
                {
                    name: "buses",
                    html: "<img class='buttonLogo' src='/images/navbar/new_icons/bus_black.svg'/>",
                    link: "/autobuses"
                },
                {
                    name: "terminal_locations",
                    html: "<img class='buttonLogo' src='/images/navbar/new_icons/locations_black.svg'/>",
                    link: "/ubicaciones"
                },
                {
                    name: "services",
                    html: "<img class='buttonLogo' src='/images/navbar/new_icons/service_black.svg'/>",
                    link: "/servicios"
                },
                {
                    name: "travel_tips",
                    html: "<img class='buttonLogo' src='/images/navbar/new_icons/tips_black.svg'/>",
                    link: "/tips-viaje"
                },
                
                {
                    name: "traveller",
                    html: "<img class='buttonLogo' src='/images/navbar/new_icons/traveller_black.svg'/>",
                    link: "https://viajero.vallartaplus.mx/"
                },
                {
                    name: "shipper",
                    html: "<img class='buttonLogo' src='/images/navbar/new_icons/package_black.svg'/>",
                    link: "https://www.gopost.mx/"
                },
                {
                    name: "hotel",
                    html: "<img class='buttonLogo' src='/images/navbar/new_icons/hotel_black.svg'/>",
                    link: "https://www.vallartaplusvacations.com/"
                }
            ]
		}
	},
	computed: {
		...mapGetters({
			language: _GlobalHelper.getters.language,
			profile: _FrequentTravellerHelper.mutations.profile
		}),

		lang: {
			set() {

			},
			get() {
				return this.language
			}
		},

		loading: {
			set(data) {
				this.setLoading(data)
			},
			get() {

			}
		}
	},
	watch: {
		travellerSession(data) {
			//console.log(data)
		}
	},
	methods: {
		...mapMutations({
			setLanguage: _GlobalHelper.mutations.language,
			setAlertSimple: _GlobalHelper.mutations.setAlertSimple,
			setAuthenticate: _GlobalHelper.mutations.setAuthenticate,
			setLoading: _GlobalHelper.mutations.loading,
			setPrfile: _FrequentTravellerHelper.mutations.profile
		}),

		changeLanguage(obj) {
			this.select_country = obj.img
			let lang = obj.tag.split(' ')
			this.setLanguage(lang[0])
		},

		checkLanguage() {
			for (let country of this.countries) {
				let lang = country.tag.split(' ')
				if (lang[0] === this.lang) {
					this.select_country = country.img
				}
			}
		},

		closeDrawer() {
			this.open_drawer = false
		},

		openSignIn() {
			this.setAuthenticate({
				show: true
			})
			this.open_drawer = false
		},
		logOut() {
			this.loading = {
				show: true,
				message: `
                <mu-container>
                    <h5>${this.$i18n.t('loading.logout')}</h5>
                </mu-container>`
            }

			this.activeTooltip = false
			setTimeout(() => {
				this.setPrfile(null)
				this.loading = { show: false, message: null }
			}, 500)
		},
	},
	created() {
		this.lang == 'es' ? (this.select_country = mx) : (this.select_country = us)
	}
}
</script>
<style lang="scss">
.img-logo-brand
{
    .size-logo {
        padding: 2px;
        max-width: 130px;
        height: 110px;
    }
}

.navbar-sections{
    height: 110px;

    .buttonLogo {
        width: 24px;
        height: 24px;
    }
    .buttonLogoCombined {
        width: 20px;
        height: 20px;
    }
    .buttonText {
        font-size: 0.85em;
        margin: 0px;
        color: black;
        text-decoration: none;
        line-height: 18px;
    }
    .buttonTextCombined {
        font-size: 0.80em;
        margin: 0px;
        color: black;
        text-decoration: none;
        line-height: 14px;
    }
    a:hover {
        text-decoration: none;
    }
}

@media only screen and (min-width: 900px) and (max-width: 1099px) {
    .img-logo-brand
    {
        .size-logo {
            padding: 1px;
            width: 70px;
            height: 65px;
        }
    }
    .navbar-sections{
        height: 65px;

        .buttonLogo {
            width: 20px;
            height: 20px;
        }
        .buttonLogoCombined {
            width: 16px;
            height: 16px;
        }
        .buttonText {
            font-size: 0.55em;
            margin: 0px;
            color: black;
            text-decoration: none;
            line-height: 12px;
        }
        .buttonTextCombined {
            font-size: 0.50em;
            margin: 0px;
            color: black;
            text-decoration: none;
            line-height: 8px;
        }

        a:hover {
            text-decoration: none;
        }
    }
}

@media only screen and (min-width: 1100px) and (max-width: 1350px) {
    .img-logo-brand
    {
        .size-logo {
            padding: 1px;
            width: 100px;
            height: 85px;
        }
    }
    .navbar-sections{
        height: 95px;

        .buttonLogo {
            width: 22px;
            height: 22px;
        }
        .buttonLogoCombined {
            width: 18px;
            height: 18px;
        }
        .buttonText {
            font-size: 0.75em;
            margin: 0px;
            color: black;
            text-decoration: none;
            line-height: 15px;
        }
        .buttonTextCombined {
            font-size: 0.70em;
            margin: 0px;
            color: black;
            text-decoration: none;
            line-height: 11px;
        }

        a:hover {
            text-decoration: none;
        }
    }
}
</style>